import { catalogLabel } from '../../../api/marcCatalogService';
/** The catalog's subfields of the field, as a plain list (the wire type is a non-empty tuple). */
var subfieldsOf = function (catalogField) { var _a; return (_a = catalogField === null || catalogField === void 0 ? void 0 : catalogField.subfields) !== null && _a !== void 0 ? _a : []; };
/** Same rule as `writableCatalogSubfield`: absent or `allowed`. */
var writable = function (policy) { return !policy || policy === 'allowed'; };
var choiceCodes = function (catalogField, field) {
    var _a;
    if (!catalogField || !writable(catalogField.input_policy))
        return [];
    var declared = new Set(((_a = field.subfields) !== null && _a !== void 0 ? _a : []).map(function (sf) { return sf.code; }));
    return subfieldsOf(catalogField)
        .filter(function (sf) { return writable(sf.input_policy) && !declared.has(sf.code); })
        .map(function (sf) { return sf.code; });
};
/**
 * The choices in catalog order, and `stale`: codes the list holds that are not a
 * choice (since declared on the field, forbidden or unknown to the ontology — a
 * hand-edited JSON, or a subfield added after the tick). The validator blocks Save
 * on those, so the editor has to show them for the admin to clear; hiding them
 * would leave an error with nothing to click.
 */
export var offerExcludedChoices = function (catalogField, field) {
    var _a;
    var excluded = (_a = field.offerExcludedSubfields) !== null && _a !== void 0 ? _a : [];
    var codes = choiceCodes(catalogField, field);
    var candidates = codes.map(function (code) {
        var entry = subfieldsOf(catalogField).find(function (sf) { return sf.code === code; });
        return { code: code, label: catalogLabel(entry === null || entry === void 0 ? void 0 : entry.label), excluded: excluded.includes(code) };
    });
    return { candidates: candidates, stale: excluded.filter(function (code) { return !codes.includes(code); }) };
};
/**
 * The list after ticking (`exclude`) or unticking `code`: catalog order, so the stored
 * value does not depend on click order (drift compares it as a value), stale codes
 * after the known ones, and `undefined` rather than `[]` once empty — the editor's
 * "absent means default" convention, and one state for drift to compare instead of two.
 */
export var withOfferExcluded = function (catalogField, current, code, exclude) {
    var set = new Set(current !== null && current !== void 0 ? current : []);
    if (exclude)
        set.add(code);
    else
        set.delete(code);
    var order = subfieldsOf(catalogField).map(function (sf) { return sf.code; });
    var rank = function (c) {
        var i = order.indexOf(c);
        return i < 0 ? order.length : i;
    };
    var next = Array.from(set).sort(function (a, b) { return rank(a) - rank(b); });
    return next.length ? next : undefined;
};
